import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this._openHandlers = new Map();

		this.events = {
			change: {
				input: "change",
			},
		};
	}

	init() {
		this.$html = document.querySelector("html");
		this.$input = this.$("input")[0];

		this._keydownHandler = this.keydown.bind(this);
		window.addEventListener("keydown", this._keydownHandler);
	}

	change(e) {
		if (e.currentTarget.checked) {
			document.documentElement.classList.add("has-burger-active");
			window.lenis.stop();
			this.call("open", {}, "menu-mobile");
		} else {
			document.documentElement.classList.remove("has-burger-active");
			window.lenis.start();
			this.close();
			this.call("close", {}, "menu-mobile");
		}
	}

	close() {
		this.$input.checked = false;
		this.call("close", {}, "header");
		document.documentElement.classList.remove("has-burger-active");
	}

	keydown(e) {
		if (e.key === "Escape" || e.keyCode === 27) {
			this.close();
		}
	}

	resize() {}

	destroy() {
		window.removeEventListener("resize", this._resizeHandler);
	}
}
